<template>
  <div>
    <section class="panel rg-intro">
      <p>Tiger Casinoでは、すべてのプレイヤー様に、安全で健全な環境のもと、オンラインカジノをお楽しみいただくことを大切にしています。</p>
      <p>ギャンブルはあくまでも娯楽の一つであり、日常生活や健康、経済状況に悪影響を及ぼさない範囲で楽しむことが重要です。</p>
      <p>ご自身のプレイ状況を適切に管理し、無理のない範囲でゲームをお楽しみいただくために、以下の内容をご確認ください。</p>
    </section>

    <section v-for="section in sections" :key="section.title" class="panel rg-section">
      <h2>{{ section.title }}</h2>
      <p v-for="text in section.texts" :key="text">
        {{ text }}
      </p>
    </section>

    <section class="panel rg-closing">
      <p>ご自身のペースを大切に、責任あるプレイを心がけましょう。</p>
      <p>ゲームの利用について不安やお困りごとがございましたら、カスタマーサポートまでお気軽にご相談ください。</p>
    </section>

    <div class="rg-back">
      <router-link class="rg-back-link" :to="limitLink">
        ‹ 自己規制に戻る
      </router-link>
    </div>
  </div>
</template>

<script>
const sections = [
  {
    title: '1 プレイ時間を管理する',
    texts: [
      'ゲームを始める前に、プレイする時間を決めておくことをおすすめします。',
      '長時間のプレイは、日常生活や健康に影響を及ぼす可能性があります。',
      '仕事や家族との時間、その他の趣味とのバランスを大切にし、適度な休憩を取りながらお楽しみください。'
    ]
  },
  {
    title: '2 無理のない予算で楽しむ',
    texts: [
      'ギャンブルに使用する金額は、生活に支障のない範囲であらかじめ設定しましょう。',
      '生活費や必要な資金をギャンブルに使用したり、負けた金額を取り戻そうとして無理に賭け金を増やしたりすることは避けてください。',
      'ギャンブルは収入を得るための手段ではなく、娯楽としてお楽しみいただくことを推奨しています。'
    ]
  },
  {
    title: '3 心身の状態に気を配る',
    texts: [
      '疲労やストレスが溜まっているとき、気分が落ち込んでいるときなどは、冷静な判断が難しくなる場合があります。',
      'そのような状態でのプレイは控え、十分な休息を取ることをおすすめします。',
      'ご自身の体調や気持ちを優先し、無理をせずゲームを楽しむことが大切です。'
    ]
  },
  {
    title: '4 アカウントは適切に管理する',
    texts: [
      'Tiger Casinoでは、原則としてお一人様につき1アカウントのみご利用いただけます。',
      '複数アカウントの作成・利用は、利用規約により禁止されています。',
      'ご自身のプレイ履歴や利用状況を適切に把握するためにも、アカウントを正しく管理し、安全なご利用をお願いいたします。'
    ]
  },
  {
    title: '5 未成年者の利用禁止',
    texts: [
      'Tiger Casinoでは、法令および当サイトの利用規約で定められた年齢に達していない方のご利用を禁止しています。',
      '年齢制限を遵守するとともに、未成年者がギャンブルにアクセスすることのないよう、アカウント情報やログイン情報の管理にも十分ご注意ください。',
      '必要に応じて、年齢確認や本人確認にご協力いただく場合があります。'
    ]
  },
  {
    title: '6 ご自身で利用を制限する',
    texts: [
      'ギャンブルの利用を一時的に控えたい場合や、プレイを続けることに不安を感じた場合は、無理に利用を続けず、ご自身に合った方法で利用を制限することが大切です。',
      'Tiger Casinoでは、プレイヤー様がご自身の利用を管理できるよう、自己制限機能の導入を進めています。',
      '自己制限の設定方法や利用期間などの詳細については、「自己制限」ページをご確認ください。'
    ]
  }
]

export default {
  name: 'TigerResponsible',
  props: {
    // 回到自己規制分頁的路由
    limitLink: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      sections
    }
  }
}
</script>
